export const exterior_view06ImageOptions = {
  angle: 'exterior_view06',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/exterior_view06.js